import { render, staticRenderFns } from "./deliveryList copy.vue?vue&type=template&id=120acaf2"
import script from "./deliveryList copy.vue?vue&type=script&lang=js"
export * from "./deliveryList copy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports